import { getTitle } from "../productHelper";

const getProductPromotions = (promo, activePromotion, savedPromotion, variants, brand = '') => {
    if (promo === 'ABC') {
        const { productA, productB, productC } = variants;
        const ActivePromotion_A = activePromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productA.variant_id)
        ));
        const SavedPromotion_A = savedPromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productA.variant_id)
        ));
        const ActivePromotion_B = activePromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productB.variant_id)
        ));
        const SavedPromotion_B = savedPromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productB.variant_id)
        ));
        const ActivePromotion_C = activePromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productC.variant_id)
        ));
        const SavedPromotion_C = savedPromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productC.variant_id)
        ));
        if (ActivePromotion_A.length > 0 || SavedPromotion_A.length > 0 ||
            ActivePromotion_B.length > 0 || SavedPromotion_B.length > 0 ||
            ActivePromotion_C.length > 0 || SavedPromotion_C.length > 0) {
            const countA = ActivePromotion_A.length + SavedPromotion_A.length;
            const countB = ActivePromotion_B.length + SavedPromotion_B.length;
            const countC = ActivePromotion_C.length + SavedPromotion_C.length;
            const _productA = `${productA.title} ${productA.variant_title}`.trim();
            const _productB = `${productB.title} ${productB.variant_title}`.trim();
            const _productC = `${productC.title} ${productC.variant_title}`.trim();
            const txtA = countA > 0 ? `<p>${_productA} ya cuenta con ${countA} ${countA === 1 ? 'promoción' : 'promociones'}</p>` : '';
            const txtB = countB > 0 ? `<p>${_productB} ya cuenta con ${countB} ${countB === 1 ? 'promoción' : 'promociones'}</p>` : '';
            const txtC = countC > 0 ? `<p>${_productC} ya cuenta con ${countC} ${countC === 1 ? 'promoción' : 'promociones'}</p>` : '';
            return {
                status: true,
                html: `${txtA}${txtB}${txtC}`
            };
        }
    } else if (['2x1', '4x3', 'DescuentoProducto', 'CompraXDescuento', 'DescuentoPieza'].includes(promo)) {
        const { productA: { title, variant_title, variant_id } } = variants;
        // hay promoción activa con el producto A seleccionado
        const ActivePromotion = activePromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(variant_id)
        ));
        // hay una promoción guardada con el producto A seleccionado
        const SavedPromotion = savedPromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(variant_id)
        ));
        if (ActivePromotion.length > 0 || SavedPromotion.length > 0) {
            const countA = ActivePromotion.length + SavedPromotion.length;
            const _productA = `${title} ${variant_title}`.trim();
            const txtA = countA === 1 ? 'promoción' : 'promociones';
            return {
                status: true,
                html: `<p>${_productA} ya cuenta con ${countA} ${txtA}</p>`
            };
        }
    } else if (['CompraDescuento', 'CompraABDescuento'].includes(promo)) {
        const { productA, productB } = variants;
        const ActivePromotion_A = activePromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productA.variant_id)
        ));
        const SavedPromotion_A = savedPromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productA.variant_id)
        ));
        const ActivePromotion_B = activePromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productB.variant_id)
        ));
        const SavedPromotion_B = savedPromotion.filter(({ variant_a, variant_b, variant_c }) => (
            [variant_a?._id, variant_b?._id, variant_c?._id].includes(productB.variant_id)
        ));
        if (ActivePromotion_A.length > 0 || SavedPromotion_A.length > 0 ||
            ActivePromotion_B.length > 0 || SavedPromotion_B.length > 0) {
            const countA = ActivePromotion_A.length + SavedPromotion_A.length;
            const countB = ActivePromotion_B.length + SavedPromotion_B.length;
            const _productA = `${productA.title} ${productA.variant_title}`.trim();
            const _productB = `${productB.title} ${productB.variant_title}`.trim();
            const txtA = countA > 0 ? `<p>${_productA} ya cuenta con ${countA} ${countA === 1 ? 'promoción' : 'promociones'}</p>` : '';
            const txtB = countB > 0 ? `<p>${_productB} ya cuenta con ${countB} ${countB === 1 ? 'promoción' : 'promociones'}</p>` : '';
            return {
                status: true,
                html: `${txtA}${txtB}`
            };
        }
    } else if (promo === 'DescuentoMarca') {
        const array_one = activePromotion.find(e => e.brand === brand);
        const array_two = savedPromotion.find(e => e.brand === brand);
        if (array_one || array_two)
            return {
                status: true,
                html: `Ya existe descuento en la marca ${brand}`
            };
    }
    return { status: false };
};

const getPromotionText = (currentPromotion, previousPromotion, setPromoTitle) => {
    const { qty_data, discount_data, discount_type_data, brand_data } = previousPromotion;
    const {
        promo, pkg_qty, discount, discount_type, brand, variant_a, variant_b, variant_c
    } = currentPromotion;
    if (promo === '2x1')
        setPromoTitle(e => ({
            ...e,
            before: `2 productos ${getTitle(variant_a.title, variant_a.variant_title)} por el precio de 1`,
            after: `2 productos ${getTitle(variant_a.title, variant_a.variant_title)} por el precio de 1`
        }));
    else if (promo === '4x3')
        setPromoTitle(e => ({
            ...e,
            before: `4 productos ${getTitle(variant_a.title, variant_a.variant_title)} por el precio de 3`,
            after: `4 productos ${getTitle(variant_a.title, variant_a.variant_title)} por el precio de 3`
        }));
    else if (promo === 'ABC')
        setPromoTitle(e => ({
            ...e,
            before: `Compra ${
                getTitle(variant_a.title, variant_a.variant_title)
            } y ${
                getTitle(variant_b.title, variant_b.variant_title)
            } y llévate ${
                getTitle(variant_c.title, variant_c.variant_title)
            } gratis`,
            after: `Compra ${
                getTitle(variant_a.title, variant_a.variant_title)
            } y ${
                getTitle(variant_b.title, variant_b.variant_title)
            } y llévate ${
                getTitle(variant_c.title, variant_c.variant_title)
            } gratis`
        }));
    else {
        const before_txt = discount_type === 'fixed' ? `$${discount}` : `${discount}%`;
        const after_txt = discount_type_data === 'fixed' ? `$${discount_data}` : `${discount_data}%`;
        if (promo === 'DescuentoProducto')
            setPromoTitle(e => ({
                ...e,
                before: `Descuento de ${before_txt} en ${getTitle(variant_a.title, variant_a.variant_title)}`,
                after: `Descuento de ${after_txt} en ${getTitle(variant_a.title, variant_a.variant_title)}`
            }));
        else if (promo === 'CompraDescuento')
            setPromoTitle(e => ({
                ...e,
                before: `Descuento de $${before_txt} en ${getTitle(variant_b.title, variant_b.variant_title)} al comprar ${getTitle(variant_a.title, variant_a.variant_title)}`,
                after: `Descuento de $${after_txt} en ${getTitle(variant_b.title, variant_b.variant_title)} al comprar ${getTitle(variant_a.title, variant_a.variant_title)}`
            }));
        else if (promo === 'CompraABDescuento')
            setPromoTitle(e => ({
                ...e,
                before: `Descuento de ${before_txt} en ${getTitle(variant_a.title, variant_a.variant_title)} y ${getTitle(variant_b.title, variant_b.variant_title)} al comprar ambos productos`,
                after: `Descuento de ${after_txt} en ${getTitle(variant_a.title, variant_a.variant_title)} y ${getTitle(variant_b.title, variant_b.variant_title)} al comprar ambos productos`
            }));
        else if (promo === 'CompraXDescuento')
            setPromoTitle(e => ({
                ...e,
                before: `Descuento de ${before_txt} en ${getTitle(variant_a.title, variant_a.variant_title)} al comprar ${pkg_qty} piezas (${pkg_qty} pack)`,
                after: `Descuento de ${after_txt} en ${getTitle(variant_a.title, variant_a.variant_title)} al comprar ${qty_data} piezas (${qty_data} pack)`
            }));
        else if (promo === 'DescuentoPieza')
            setPromoTitle(e => ({
                ...e,
                before: `${before_txt} de descuento en el segundo producto del mismo tamaño (${getTitle(variant_a.title, variant_a.variant_title)})`,
                after: `${after_txt} de descuento en el segundo producto del mismo tamaño (${getTitle(variant_a.title, variant_a.variant_title)})`,
            }));
        else if (promo === 'DescuentoMarca')
            setPromoTitle(e => ({
                ...e,
                before: `${before_txt} de descuento en marca ${brand}`,
                after: `${after_txt} de descuento en marca ${brand_data}`,
            }));
    }
};

const getPromotionCardText = (promotion) => {
    const {
        promo, pkg_qty, discount, discount_type, brand, variant_a, variant_b, variant_c
    } = promotion;
    if (promo === '2x1')
        return `2 productos ${getTitle(variant_a.title, variant_a.variant_title)} por el precio de 1`;
    else if (promo === '4x3')
        return `4 productos ${getTitle(variant_a.title, variant_a.variant_title)} por el precio de 3`;
    else if (promo === 'ABC')
        return `Compra ${
            getTitle(variant_a.title, variant_a.variant_title)
        } y ${
            getTitle(variant_b.title, variant_b.variant_title)
        } y llévate ${
            getTitle(variant_c.title, variant_c.variant_title)
        } gratis`;
    else {
        const txt = discount_type === 'fixed' ? `$${discount}` : `${discount}%`;
        if (promo === 'DescuentoProducto')
            return `Descuento de ${txt} en ${getTitle(variant_a.title, variant_a.variant_title)}`;
        else if (promo === 'CompraDescuento')
            return `Descuento de ${txt} en ${getTitle(variant_b.title, variant_b.variant_title)} al comprar ${getTitle(variant_a.title, variant_a.variant_title)}`;
        else if (promo === 'CompraABDescuento')
            return `Descuento de ${txt} en ${getTitle(variant_a.title, variant_a.variant_title)} y ${getTitle(variant_b.title, variant_b.variant_title)} al comprar ambos productos`;
        else if (promo === 'CompraXDescuento')
            return `Descuento de ${txt} en ${getTitle(variant_a.title, variant_a.variant_title)} al comprar ${pkg_qty} piezas (${pkg_qty} pack)`;
        else if (promo === 'DescuentoPieza')
            return `Descuento de ${txt} en el segundo producto del mismo tamaño (${getTitle(variant_a.title, variant_a.variant_title)})`;
        else if (promo === 'DescuentoMarca')
            return `Descuento de ${txt} en marca ${brand}`;
    }

    return 'Promoción';
};

const getPromoModel = (promotion) => {
    const { _id, promo, pkg_qty, discount, discount_type, brand, startDate, endDate } = promotion;
    if (['2x1', '4x3', 'ABC'].includes(promo))
        return {
            status: true, url: 'promotion/update-promo-one',
            model: { _id, start_date: startDate, end_date: endDate }
        };
    else if (['DescuentoProducto', 'CompraDescuento', 'CompraABDescuento'].includes(promo))
        return {
            status: true, url: 'promotion/update-promo-two',
            model: { _id, discount, discount_type, start_date: startDate, end_date: endDate }
        };
    else if (['CompraXDescuento', 'DescuentoPieza'].includes(promo))
        return {
            status: true, url: 'promotion/update-promo-three',
            model: { _id, pkg_qty, discount, discount_type, start_date: startDate, end_date: endDate }
        };
    else if (promo === 'DescuentoMarca')
        return {
            status: true, url: 'promotion/update-promo-four',
            model: { _id, discount, discount_type, brand, start_date: startDate, end_date: endDate }
        };
    else
        return { status: false };
};

export {
    getProductPromotions,
    getPromotionText,
    getPromotionCardText,
    getPromoModel
};